import React from 'react';
import '../../css/ActionButtons.css';
import {
    ArrowLeftIcon,
    CalendarIcon,
    CheckIcon,
    ClockIcon,
    CreditCardIcon,
    EyeIcon,
    FileTextIcon,
    MapPinIcon,
    NewFileIcon,
    PencilIcon,
    PrinterIcon,
    SearchIcon,
    UndoCircleIcon,
    XIcon,
} from './actionIcons';
import {withFocusOnClick} from '../../utils/focusUtils';

const VARIANT_CONFIG = {
    new: {className: 'new-button', Icon: NewFileIcon, defaultTitle: 'Novo'},
    edit: {className: 'edit-button', Icon: PencilIcon, defaultTitle: 'Editar'},
    delete: {className: 'remove-button', Icon: XIcon, defaultTitle: 'Excluir'},
    confirm: {className: 'confirm-button', Icon: CheckIcon, defaultTitle: 'Confirmar'},
    reverse: {className: 'finish-button', Icon: UndoCircleIcon, defaultTitle: 'Estornar'},
    search: {className: 'search-button', Icon: SearchIcon, defaultTitle: 'Buscar'},
    availability: {className: 'availability-button', Icon: CalendarIcon, defaultTitle: 'Disponibilidade'},
    view: {className: 'edit-button', Icon: EyeIcon, defaultTitle: 'Ver'},
    maps: {className: 'search-button', Icon: MapPinIcon, defaultTitle: 'Google Maps'},
    time: {className: 'availability-button', Icon: ClockIcon, defaultTitle: 'Alterar horário'},
    term: {className: 'confirm-button', Icon: FileTextIcon, defaultTitle: 'Termo'},
    extend: {className: 'availability-button', Icon: CalendarIcon, defaultTitle: 'Prorrogar'},
    back: {className: 'back-button', Icon: ArrowLeftIcon, defaultTitle: 'Voltar'},
    payments: {className: 'confirm-button', Icon: CreditCardIcon, defaultTitle: 'Pagamentos'},
    print: {className: 'search-button', Icon: PrinterIcon, defaultTitle: 'Imprimir'},
    file: {className: 'confirm-button', Icon: FileTextIcon, defaultTitle: 'Arquivo'},
};

const ActionIconButton = ({
    variant,
    title,
    onClick,
    disabled,
    type = 'button',
    className = '',
    style,
    children,
    ...rest
}) => {
    const {className: variantClass, Icon, defaultTitle} = VARIANT_CONFIG[variant];
    const tooltip = title ?? defaultTitle;

    return (
        <button
            type={type}
            className={`action-icon-button ${variantClass} ${className}`.trim()}
            onClick={withFocusOnClick(onClick)}
            disabled={disabled}
            title={tooltip}
            aria-label={tooltip}
            style={style}
            {...rest}
        >
            <Icon/>
            {children}
        </button>
    );
};

export default ActionIconButton;
